import React from "react";
import * as OrgConfig from "src/generated/hooks/org-config/requests";
import { isNullOrUndefined } from "src/services/predicates";
import * as RD from "src/types/remoteData";
import { useOrgConfig } from "./useOrgConfig";

/**
 * Validate whether the current orgPath is a valid organi
 * @returns true if valid, false if invalid
 */
export function useValidateOrgPath(): RD.RemoteData<Error, boolean> {
  // We use Auth0.json as a proximation of a valid organization since
  // all valid organization should have Auth0 clientID.
  const auth0RD = useOrgConfig<OrgConfig.Auth0Config>("Auth0");

  return React.useMemo(
    () => auth0RD.map((config) => (isNullOrUndefined(config) ? false : true)),
    [auth0RD]
  );
}
